<template>
  <div class="plans">
    <div class="top-action">
      <div class="top-title">
        {{
          $store.state.homeObj.show_degree_conditions == "1"
            ? "毕业/学位"
            : "毕业"
        }}
      </div>
    </div>
    <a-spin :spinning="applySpinning">
      <div class="content">
        <div class="graduation">
          <div class="gra-title">毕业条件</div>
          <table class="table">
            <tr>
              <th>序号</th>
              <th style="text-align: left; padding-left: 8px">条件</th>
              <th>状态</th>
            </tr>
            <tr v-for="(item, index) in graArr" :key="index">
              <td>{{ index + 1 }}</td>
              <td style="text-align: left; padding-left: 8px">
                {{ item.itemDesc }}
              </td>
              <td>
                <div v-if="item.itemType != 'label'">
                  <div v-if="item.status == 1">
                    <a-icon
                      type="check"
                      style="color: #87d068; margin-right: 8px"
                    />已完成
                  </div>
                  <div v-else>进行中</div>
                </div>
                <div v-if="item.itemType == 'label'">''</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="margin-top-30"></div>
        <div
          v-if="$store.state.homeObj.show_degree_conditions == '1'"
          class="degree"
        >
          <div class="gra-title">学位条件</div>
          <table class="table">
            <tr>
              <th>序号</th>
              <th style="text-align: left; padding-left: 8px">条件</th>
              <th>状态</th>
            </tr>
            <tr v-for="(item, index) in degArr" :key="index">
              <td>{{ index + 1 }}</td>
              <td style="text-align: left; padding-left: 8px">
                {{ item.itemDesc }}
              </td>
              <td>
                <div v-if="item.itemType != 'label'">
                  <div v-if="item.status == 1">
                    <a-icon
                      type="check"
                      style="color: #87d068; margin-right: 8px"
                    />已完成
                  </div>
                  <div v-else>进行中</div>
                </div>
                <div v-if="item.itemType == 'label'">''</div>
              </td>
            </tr>
          </table>
        </div>
        <!-- <div class="pagination">
          <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
        </div> -->
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ApplyList",
  data: function () {
    return {
      graArr: [],
      degArr: [],
      applySpinning: false,
    };
  },

  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    getGraList() {
      this.applySpinning = true;
      this.axios
        .get(`/biz/home/rule/list?type=1`)
        .then((res) => {
          if (res.success) {
            this.graArr = res.result;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },
    getDegList() {
      this.applySpinning = true;
      this.axios
        .get(`/biz/home/rule/list?type=2`)
        .then((res) => {
          if (res.success) {
            this.degArr = res.result;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },
  },
  created() {
    this.getGraList();
    if (this.$store.state.homeObj.show_degree_conditions == "1") {
      this.getDegList();
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  min-height: calc(100vh - 584px);

  .content {
    background: #fff;
    padding: 24px 30px;
    .pagination {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px 0;
    }

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      margin-top: 10px;
      color: #999999;
      width: 100%;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 26px;
    line-height: 26px;
    padding: 0;
    background: #2caf7a;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 4px;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  td {
    text-align: center;
    vertical-align: middle;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }
}
.top-action {
    .top-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom:30px;
    }
}
.gra-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/graduatonCondition/components/Condition.vue